import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import './i18n';
import { applyAccent, getStoredAccent } from "./assets/theme/accents";
import { initAnalytics } from "./utils/analytics";

// Apply the saved accent before first paint so there is no color flash.
applyAccent(getStoredAccent());
initAnalytics();

ReactDOM.render(<App />, document.getElementById("root"));
